export default __webpack_public_path__ + "images/JR.b520f53.png";